import { Phone, Mail, MapPin, Instagram } from "lucide-react";

export default function TopBar() {
  return (
    <div
      data-testid="site-topbar"
      className="bg-[#0F172A] border-b border-white/10"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 h-10 flex items-center justify-between text-[12.5px] text-white/75">
        <div className="flex items-center gap-6 overflow-hidden">
          <a
            href="tel:9345093450"
            className="inline-flex items-center gap-2 hover:text-white transition-colors whitespace-nowrap"
          >
            <Phone size={13} className="text-[#C9A227]" />
            9345093450
          </a>
          <span className="hidden sm:inline text-white/20">|</span>
          <a
            href="mailto:customercare@vishcapital.com"
            className="hidden sm:inline-flex items-center gap-2 hover:text-white transition-colors whitespace-nowrap"
          >
            <Mail size={13} className="text-[#C9A227]" />
            customercare@vishcapital.com
          </a>
          <span className="hidden lg:inline text-white/20">|</span>
          <span className="hidden lg:inline-flex items-center gap-2 whitespace-nowrap">
            <MapPin size={13} className="text-[#C9A227]" />
            2nd floor , Tidel neo , Thirumuruganpoondi , Tirupur - 641652
          </span>
        </div>

        <div className="flex items-center gap-2.5 shrink-0">
          <a
            href="https://www.instagram.com/vish.capital"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="inline-flex h-6 w-6 items-center justify-center rounded-md bg-white/10 text-white/80 hover:bg-[#C9A227] hover:text-[#0F172A] transition-colors"
          >
            <Instagram size={12} strokeWidth={1.75} />
          </a>
        </div>
      </div>
    </div>
  );
}